import { createFilterOptions, TextField } from '@mui/material';
import { useMemo } from 'react';

import { VerticalAutocomplete } from '@styles/Admin-tools/TeamManagerStyle';

import { NTeamManager } from '../interfaces';

interface IManagerProps {
  value?: NTeamManager.User[];
  data?: NTeamManager.User[];

  onChange(value: NTeamManager.User[]): void;
}

export const Managers = ({ value, data, onChange }: IManagerProps) => {
  const filterOptions = createFilterOptions<NTeamManager.User>({
    matchFrom: 'start',
    stringify: (option) => option.userName,
  });

  const isOptionEqualToValue = (option: NTeamManager.User, value: NTeamManager.User) => {
    return option.userId === value.userId;
  };

  const sortedData = useMemo(() => (
    data?.sort((a: NTeamManager.User, b: NTeamManager.User) => a.userName.localeCompare(b.userName))
  ), [data]);

  return (
    <VerticalAutocomplete
      multiple
      disableClearable
      options={sortedData || []}
      value={value || []}
      getOptionLabel={(option: NTeamManager.User) => option.userName}
      filterOptions={filterOptions}
      isOptionEqualToValue={isOptionEqualToValue}
      renderInput={(params) => (
        <TextField {...params} label="Managers" placeholder="Select Managers" InputLabelProps={{ shrink: true }} />
      )}
      onChange={(_event, value: NTeamManager.User[], _reason) => onChange(value)}
    />
  );
};
